import {
	Component,
	Input,
	Output,
	SimpleChanges,
	OnChanges,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	ViewEncapsulation,
} from '@angular/core';

@Component({
	standalone: false,
	selector: 'visiba-step',
	template: `
		<div
			class="step"
			*ngFor="let step of steps; let i = index"
			[class.done]="i < stepIndex"
			[class.current]="step.alias === currentStep"
		>
			<span *ngIf="step.noTranslate">{{ step.description }}</span>
			<span *ngIf="!step.noTranslate">{{ step.description | translate }}</span>
			<visiba-svg *ngIf="i !== steps.length - 1" a="ArrowRight"></visiba-svg>
		</div>
	`,
	styleUrls: ['../Css/Components/visibaStep.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VisibaStepComponent implements OnChanges {
	@Input() steps: Array<{ alias: string; description: string; noTranslate?: boolean }> = [];
	@Input() currentStep: string = null;
	public stepIndex: number = 0;

	constructor(private _changeDetectorRef: ChangeDetectorRef) {}

	ngOnChanges(changes: SimpleChanges) {
		this.setCurrentStep(changes['currentStep'].currentValue);
	}

	public setSteps(steps: Array<{ alias: string; description: string; noTranslate?: boolean }>) {
		this.steps = steps;
		this.setCurrentStep(this.currentStep);
	}

	public setCurrentStep(step: string) {
		this.currentStep = step;
		this.stepIndex = this.steps.findIndex((x) => x.alias === step);

		window.setTimeout(() => {
			this._changeDetectorRef.markForCheck();
		}, 0);
	}
}
